module.exports = __WEBPACK_EXTERNAL_MODULE_single_spa_e1524a87__;